import React from 'react';
import PropTypes from 'prop-types';

const ViewModal = ({ modalId, header, children }) => {
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div
            className="modal-header"
            style={{
              padding: '10px',
              textAlign: 'center',
              color: '#d63835',
              fontSize: '15px',
            }}
          >
            {header}
            <div className="pull-right">
              <button
                className="btn btn-circle"
                type="button"
                data-dismiss="modal"
              >
                <i className="fa fa-times" />
              </button>
            </div>
          </div>
          <div className="modal-body">{children}</div>
          <div
            className="modal-footer"
            style={{ padding: '5px', textAlign: 'center' }}
          />
        </div>
      </div>
    </div>
  );
};

ViewModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  header: PropTypes.string,
  modalId: PropTypes.string.isRequired,
};

ViewModal.defaultProps = {
  children: '',
  header: '',
};

export default ViewModal;
